import { createContext, useContext, useEffect, useMemo, useState } from "react";

const KEY = "queonda.mode";
const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => {
    try {
      return localStorage.getItem(KEY) || "general";
    } catch (_e) {
      return "general";
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-mode", mode);
    try {
      localStorage.setItem(KEY, mode);
    } catch (_e) {
      /* localStorage may be blocked */
    }
    // Keep PWA / browser theme color in sync
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", "#0F172A");
  }, [mode]);

  const value = useMemo(
    () => ({
      mode,
      isNegocio: mode === "negocio",
      setMode,
      toggle: () => setMode((m) => (m === "general" ? "negocio" : "general")),
    }),
    [mode],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme debe usarse dentro de ThemeProvider");
  return ctx;
}
